import { Component } from '@angular/core';
import { AppService } from './app.service';
import { LocalStorageService } from 'ng2-webstorage';
@Component({
  selector: 'app-root',
  template: `<p-growl [(value)]="msgs"></p-growl> 
  <ng-progress [positionUsing]="'marginLeft'" [minimum]="0.15" [maximum]="1"
  [speed]="200" [showSpinner]="false" [direction]="'rightToLeftIncreased'"
  [color]="'#1abc9c'" [trickleSpeed]="250" [thick]="true" [ease]="'linear'"
></ng-progress>
  <router-outlet (activate)="onActivate($event, outlet)" #outlet><spinner></spinner></router-outlet>`
})
export class AppComponent {
  public msgs: any;
  constructor(private appService: AppService, private localStorage: LocalStorageService) {
    this.getURls();
    var userLang = navigator.language.split('-')[0];
        //userLang = /(in|de|en|hr)/gi.test(userLang) ? userLang : 'en';
  }

  private getURls() {
    // if (this.localStorage.retrieve('baseUrl') == undefined || this.localStorage.retrieve('baseUrl') == null)
    //  {
      this.appService.getbaseUrl().subscribe(items => {
        this.localStorage.store('baseUrl', items.portalBaseUrl);
        this.localStorage.store('fileUrl', items.fileDownloadUrl);
      })
    //}
  }
  onActivate(e, outlet) {
    outlet.scrollTop = 0;
  }
}


// WEBPACK FOOTER //
// /builds/yaratechnologies/talkative-parents-portal/src/app/app.component.ts